module.exports = __webpack_public_path__ + "static/media/checklist.205f5a25.png";